var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "general/user-group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 7.5C6.5 6.11929 7.61929 5 9 5C10.3807 5 11.5 6.11929 11.5 7.5C11.5 8.88071 10.3807 10 9 10C7.61929 10 6.5 8.88071 6.5 7.5ZM9 3C6.51472 3 4.5 5.01472 4.5 7.5C4.5 9.98528 6.51472 12 9 12C11.4853 12 13.5 9.98528 13.5 7.5C13.5 5.01472 11.4853 3 9 3ZM16 9.5C16 8.94772 16.4477 8.5 17 8.5C17.5523 8.5 18 8.94772 18 9.5C18 10.0523 17.5523 10.5 17 10.5C16.4477 10.5 16 10.0523 16 9.5ZM17 6.5C15.3431 6.5 14 7.84315 14 9.5C14 11.1569 15.3431 12.5 17 12.5C18.6569 12.5 20 11.1569 20 9.5C20 7.84315 18.6569 6.5 17 6.5ZM2 17C2 14.7909 3.79086 13 6 13H12C14.2091 13 16 14.7909 16 17V21H2V17ZM6 15C4.89543 15 4 15.8954 4 17V19H14V17C14 15.8954 13.1046 15 12 15H6ZM22 17C22 15.3431 20.6569 14 19 14H17V16H19C19.5523 16 20 16.4477 20 17V18H17V20H22V17Z",
    fill: "#3366CC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.207953a96f3808f1fb7fcdc76f0b733b.svg";
export { ForwardRef as ReactComponent };